import PropTypes from 'prop-types'
import React, { Fragment } from 'react'
import styled, { css } from 'styled-components'

const StyledComponent = styled(({css, ...rest}) => <div {...rest} />)`
  background-color: ${props => props.theme.cWhite};
  border-radius: ${props => props.theme.borderRadius};
  box-shadow: ${props => props.theme.shadow};
  border: ${p => p.theme.border_card};
  ${p => p.m && css`
  margin: ${p => p.m};
`};
   ${p => p.p && css`
  margin: ${p => p.p};
`}
  ${p => p.css};

`

const CardTemplate = (props) => {
  return (
    props.without_wrappers ? <Fragment>{props.children}</Fragment> : <StyledComponent {...props} />
  )
}
CardTemplate.propTypes = {
  css: PropTypes.oneOfType(
    [
      PropTypes.string,
      PropTypes.array,
      PropTypes.object,
    ]
  ),
}

export default CardTemplate
export { default as CardInner } from 'templates/CardTemplate/_CardInner'
export { default as CardHeader } from 'templates/CardTemplate/_CardHeader'
export { default as CardFooter } from 'templates/CardTemplate/_CardFooter'
export { default as CardTitle } from 'templates/CardTemplate/_CardTitle'

